import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { RecentProductType } from '../../@types/product';
import { getGuestRecentProducts, getRecentProducts } from '../../api/product';
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar';
import MyShoppingProductList from '../../components/myshopping/ProductList';
import { useCommonContext } from '../../components/provider/CommonProvider';
import { PageTitle } from '../../components/title/PageTitle';
import '../../css/myshopping.css';
import { getParsedSessionStorageItem } from '../../js/script';

export default function RecentView() {
  const [item, setItem] = useState<RecentProductType[]>([]);
  const title: string = 'recent';
  const [like, setLike] = useState<boolean>(false);

  const { setIsLottie, hasAccessToken } = useCommonContext();

  useEffect(() => {
    if (hasAccessToken) {
      getRecentProducts(1)
        .then((res) => {
          setItem(res.data);
          setIsLottie(false);
        })
        .catch((err) => console.log(err));
    } else {
      const product = getParsedSessionStorageItem('mallProductNo');
      if (product.length !== 0) {
        const productParse = product;
        getGuestRecentProducts(productParse)
          .then((res) => {
            setItem(res.data);
            setIsLottie(false);
          })
          .catch((err) => console.log(err));
      }
    }
  }, [like]);

  //  최근 본 내역 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap');
    item.length === 0 ? contentsWrap?.classList.add('full') : contentsWrap?.classList.remove('full');
  }, []);

  return (
    <>
      <div className="main_wrap">
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar item={item} />
          <div className="myshopping_wrap">
            <PageTitle>최근 본 상품</PageTitle>
            <MyShoppingProductList item={item} title={title} />
          </div>
        </div>
      </div>
    </>
  );
}
